import React from "react";
import { Dialog } from "primereact/dialog";

type BaseModalProp = {
    styleClass?: string;
    disabled?: false;
    label?: string;
    id?: string;
    value?: string;
    hasError?: boolean;
    onSelect?: (place: any) => void;
    change?: () => void;
    errorMsg?: string;
    visible: boolean;
    closable: boolean;
    closeModal: () => void;
    modalSize: "small" | "medium" | "large" | "extra-large";
    children?: any;
    styles?: string;
};

const BaseModal: React.FC<BaseModalProp> = ({
    visible = false,
    closable = false,
    closeModal,
    modalSize,
    children,
    styles
}) => {
    return (
        <Dialog
            header=""
            footer={null}
            closable={closable}
            visible={visible}
            draggable={false}
            closeOnEscape={true}
            modal
            resizable={false}
            onHide={closeModal}
            className={`w-11/12 md:max-w-md mx-auto ${modalSize === "small" && "lg:max-w-md"} ${
                modalSize === "medium" && "lg:max-w-lg"
            } ${modalSize === "large" && "lg:max-w-2xl"} ${modalSize === "extra-large" && "lg:max-w-4xl"} relative ${styles}`}
            breakpoints={{ "960px": "70vw", "640px": "90vw" }}
            // className="lg:w-[30vw] w-11/12"
        >
            <div>{children}</div>
        </Dialog>
    );
};

export default BaseModal;
